import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 48 48" fill="none" {...props}>
      <title>{props.title || 'Glasses'}</title>
      <g xmlns="http://www.w3.org/2000/svg">
        <path
          d="M24 0C37.2514 0 48 10.7486 48 24C48 37.2514 37.2514 48 24 48C10.7486 48 0 37.2514 0 24C0 10.7486 10.7486 0 24 0Z"
          fill="#FFD6B0"
        />
        <path
          d="M11.2427 24.25L14.871 15.2165C15.7079 13.2653 17.6268 12.0002 19.75 12M37.0073 24.25L33.379 15.2165C32.5421 13.2653 30.6232 12.0002 28.5 12M35.5 35.625H28.3495C27.8857 35.6249 27.4409 35.4407 27.1128 35.1128L24.125 32.125L21.1372 35.1128C20.8091 35.4407 20.3643 35.6249 19.9005 35.625H12.75C11.7835 35.625 11 34.8415 11 33.875V25.125C11 24.1585 11.7835 23.375 12.75 23.375H35.5C36.4665 23.375 37.25 24.1585 37.25 25.125V33.875C37.25 34.8415 36.4665 35.625 35.5 35.625ZM28.5 32.125H33.75V26.875H26.75L28.5 32.125ZM14.5 32.125H19.75L21.5 26.875H14.5V32.125Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </Icon>
  )
}
